import { Flex, FormLabel, Input } from "@chakra-ui/react";
import { FieldTemplateProps, WidgetProps } from "@rjsf/utils";
import { useState } from "react";

/**
 * Custom FileWidget for BrostarForm.
 * - Respects the accept prop from ui:options
 * - Returns the File object (Blob) instead of a base64 string
 */
export const FileWidget = (props: WidgetProps) => {
  const { id, name, placeholder, readOnly, onChange, uiSchema, required, label, value } =
    props as WidgetProps<Blob>;
  const [isDragHover, setIsDragHover] = useState(false);
  const [filePath, setFilePath] = useState<string>("");

  const onFileChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    const target = event.target;
    if (!target.files) return;
    const file = target.files[0];
    setFilePath(target.value);
    onChange(file);
  };

  const accept = uiSchema?.["ui:options"]?.accept as string | undefined;

  const { FieldTemplate } = props.registry.templates;

  // This is a workaround for a weird case where the value of the file widget becomes an empty object
  // instead of undefined when you clear the file input.
  // This causes the custom validation to break because it expects a Blob or undefined.
  if (value && typeof value === "object" && !("name" in value)) {
    onChange(undefined);
  }

  return (
    <FieldTemplate {...(props as unknown as FieldTemplateProps)}>
      <>
        <FormLabel htmlFor={id} mb="2">
          {label}
        </FormLabel>
        <Flex
          pos="relative"
          onDragEnter={() => setIsDragHover(true)}
          onMouseLeave={() => setIsDragHover(false)}
          onDragLeave={() => setIsDragHover(false)}
        >
          <Input
            pt={1}
            h="input"
            borderColor={isDragHover ? "primary" : undefined}
            _hover={{ borderColor: isDragHover ? "primary" : undefined }}
            name={name}
            id={id}
            autoComplete="off"
            placeholder={placeholder}
            onChange={onFileChanged}
            value={filePath}
            readOnly={!!readOnly}
            type="file"
            accept={accept}
            isRequired={required}
            step={"any"} // no stepping is implied for number input type
          />
        </Flex>
      </>
    </FieldTemplate>
  );
};
